import { LEGAL_RULES } from '../../data/sessions';
import { C } from './shared';

export default function LegalTab() {
  const colorFor = (id) => {
    const danger = ['L1','L2','L3','L4','L5','L6','L7','L8','L9'];
    const warn   = ['L10','L11'];
    if (danger.includes(id)) return C.danger;
    if (warn.includes(id))   return C.warning;
    return C.info;
  };
  return (
    <div style={{ display: 'grid', gap: 8 }}>
      <div style={{ background: C.card, borderRadius: 10, padding: 16,
        border: '1px solid ' + C.danger + '44', marginBottom: 4 }}>
        <div style={{ color: C.danger, fontWeight: 800, fontSize: 14, marginBottom: 4 }}>
          These rules are permanent and non-negotiable. Check before shipping any new feature.
        </div>
        <div style={{ color: C.muted, fontSize: 12 }}>
          Source: src/data/sessions.js LEGAL_RULES — edit there. Never add rules only here.
        </div>
      </div>
      {LEGAL_RULES.map((item) => (
        <div key={item.id} style={{ background: C.card, borderRadius: 8, padding: '12px 16px',
          borderLeft: '3px solid ' + colorFor(item.id), border: '1px solid ' + C.border }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ color: colorFor(item.id), fontFamily: 'monospace', fontSize: 11,
              minWidth: 28 }}>{item.id}</span>
            <span style={{ color: C.subtle, fontSize: 12, lineHeight: 1.5 }}>{item.rule}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

